<template>
	<div>
		<v-container fluid grid-list-lg class="py-3">
			<v-layout row wrap align-end>
				<v-flex grow class="pa-0">
					<v-text-field
						clearable
						prepend-inner-icon="search"
						placeholder="Recherchez les cartes d'un titre"
						browser-autocomplete="off"
						hide-details
						class="grv-input mt-0 pt-0"
						ref="search-input"
						v-model="title"
						:loading="loading"
						@click:clear="title = null; updateUrl()"
						@keyup.enter="onSearchEnter()"
						@change="updateUrl()">
					</v-text-field>
				</v-flex>

				<v-flex shrink class="py-0 pr-0">
					<v-autocomplete
						dense
						clearable
						hide-details
						:disabled="loading || card_type_disabled"
						class="grv-input mt-0 pt-0"
						:menu-props="{contentClass: 'grv-menu'}"
						:items="dropdowns.card_types"
						v-model="card_type"
						@click:clear="card_type=null;updateUrl()"
						@change="updateUrl()"
						placeholder="Type">
					</v-autocomplete>
				</v-flex>

				<v-flex shrink class="pr-0 py-0">
					<v-autocomplete
						dense
						clearable
						hide-details
						:disabled="loading || !dropdowns.card_sub_types[card_type]"
						class="grv-input mt-0 pt-0"
						:menu-props="{contentClass: 'grv-menu'}"
						:items="dropdowns.card_sub_types[card_type]"
						v-model="card_sub_type"
						@click:clear="card_sub_type=null;updateUrl()"
						@change="updateUrl()"
						placeholder="Sub Type">
					</v-autocomplete>
				</v-flex>

				<v-flex shrink class="pa-0">
					<v-btn
						icon flat
						@click="onSearchChange()">
						<v-icon>refresh</v-icon>
					</v-btn>
				</v-flex>

				<v-flex shrink v-if="!no_select">
					<span xs3 v-if="multiselect" class="text-right">
						<v-menu offset-y :close-on-content-click="false">
							<template v-slot:activator="{ on }">
								<v-btn
									large
									:disabled="selected.length === 0"
									color="primary color--text"
									class="text-none ma-0"
									v-on="on">
									{{ selected.length }} Carte(s) Sélectionnée(s)
								</v-btn>
								<v-btn
									large
									:disabled="selected.length === 0"
									color="primary color--text"
									class="text-none ma-0"
									@click="$emit('selected', selected)">
									<v-icon large>arrow_forward</v-icon>
								</v-btn>
							</template>
							<v-list dense class="background darken-1">
								<v-list-tile
									v-for="(item, i) in selected"
									:key="'selected' + i"
									@click="table.deselectRow(selected_rows[i])">
									<v-list-tile-avatar>
										<v-icon color="primary">check_box</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-title>
										{{ item.id }} - {{ item.title }}
									</v-list-tile-title>
								</v-list-tile>
							</v-list>
						</v-menu>
					</span>
					<span xs2 v-else class="text-right">
						<v-btn
							large
							:disabled="selected.length === 0"
							color="primary color--text"
							class="text-none ma-0"
							@click="$emit('selected', selected)">
							<span v-if="selected[0]">
								{{ selected[0].id }} - {{ selected[0].title }}
							</span>
							<v-icon large right>arrow_forward</v-icon>
						</v-btn>
					</span>
				</v-flex>

				<v-spacer></v-spacer>

				<v-flex shrink class="pa-0">
					<v-btn v-if="create_movie_tree_id"
						color="primary color--text"
						flat icon large
						class="ma-0"
						@click="displayLauncher(create_movie_tree_id)"
						:title="create_movie_tree_label">
						<v-icon>movie</v-icon>
					</v-btn>

					<v-btn v-if="create_tv_show_tree_id"
						color="primary color--text"
						flat icon large
						class="ma-0"
						@click="displayLauncher(create_tv_show_tree_id)"
						:title="create_tv_show_tree_label">
						<v-icon>tv</v-icon>
					</v-btn>
				</v-flex>
			</v-layout>
		</v-container>

		<div
			id="cards-table"
			ref="cards-table">
		</div>

		<div
			id="hidden-footer"
			ref="hidden-footer"
			style="display: none;">
		</div>

		<v-footer
			id="footer"
			class="tabulator-footer"
			color="background darken-1 px-3">
			<v-layout row wrap align-center>
				<v-spacer></v-spacer>
				<span v-if="pageMax">
					<v-btn
						flat icon small
						class="ma-0"
						:disabled="table.getPage() === 1"
						@click="table.setPage('first')">
						<v-icon>first_page</v-icon>
					</v-btn>
					<v-btn
						flat icon small
						class="ma-0"
						:disabled="table.getPage() === 1"
						@click="table.previousPage()">
						<v-icon>chevron_left</v-icon>
					</v-btn>
					<span class="mx-2">
						<v-chip label small color="background ligthen-1">
							Page {{ table.getPage() }} / {{ pageMax }}
						</v-chip>
					</span>
					<v-btn
						flat icon small
						class="ma-0"
						:disabled="table.getPage() === pageMax"
						@click="table.nextPage()">
						<v-icon>chevron_right</v-icon>
					</v-btn>
					<v-btn
						flat icon small
						class="ma-0"
						:disabled="table.getPage() === pageMax"
						@click="table.setPage('last')">
						<v-icon>last_page</v-icon>
					</v-btn>
				</span>
				<span class="subheading ml-2">
					{{ dataCount }} Cards
				</span>
				<v-spacer></v-spacer>
				<v-menu top left>
					<template v-slot:activator="{ on }">
						<v-btn
							small icon flat
							class="my-0"
							v-on="on">
							<v-icon>cloud_download</v-icon>
						</v-btn>
					</template>
					<v-list dense class="background darken-1">
						<v-list-tile @click="table.download('csv', 'data.csv', {bom:true})">
							<v-list-tile-title>CSV</v-list-tile-title>
						</v-list-tile>
						<v-list-tile @click="table.download('json', 'data.json')">
							<v-list-tile-title>JSON</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
			</v-layout>
		</v-footer>

		<v-menu
			v-model="menu_show"
			:position-x="menu_x"
			:position-y="menu_y"
			absolute
			dense
			offset-y
			content-class="context-menu">
			<v-list class="background darken-1 pa-0">
				<v-list-tile @click="show_tree=!show_tree;setTableData()">
					<v-list-tile-avatar>
						<v-icon v-if="show_tree">view_list</v-icon>
						<v-icon v-else>unfold_more</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-title>
						<div v-if="show_tree">
							List View
						</div>
						<div v-else>
							Tree View
						</div>
					</v-list-tile-title>
				</v-list-tile>
				<v-divider class="ma-0"></v-divider>
				<v-list-tile v-show="context_card!==null && (context_card.type==='show' || context_card.type==='movie')"
							@click="indexRootCard()">
					<v-list-tile-avatar>
						<v-icon>storage</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-title>
						<div>
							Index Root Card
						</div>
					</v-list-tile-title>
				</v-list-tile>
				<v-list-tile v-show="context_card!==null && context_card.type==='show'"
							@click="createSeasonTree()">
					<v-list-tile-avatar>
						<v-icon>queue_play_next</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-title>
						<div>
							Create Season Tree
						</div>
					</v-list-tile-title>
				</v-list-tile>
				<v-list-tile v-show="context_card!==null && (context_card.type==='movie' || context_card.type==='season')"
							@click="createSubCard()">
					<v-list-tile-avatar>
						<v-icon>add_to_photos</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-title>
						<div>
							Create Sub Babel Card
						</div>
					</v-list-tile-title>
				</v-list-tile>
				<v-list-tile @click="updateBabelCard()">
					<v-list-tile-avatar>
						<v-icon>sync</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-title>
						<div>
							Update Babel Card
						</div>
					</v-list-tile-title>
				</v-list-tile>
			</v-list>
		</v-menu>

		<CardDrawer
			:visible="drawer.visible"
			:card="drawer.card"
			@close="drawer.card=null;drawer.visible=false">
		</CardDrawer>
	</div>
</template>

<script>
import Tabulator from 'tabulator-tables'
import 'tabulator-tables/dist/css/tabulator_midnight.min.css'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import CardDrawer from '@/components/babel_card_right_drawer.vue'
momentDurationFormatSetup(moment)
export default {
	props: [ 'multiselect', 'no_select', 'props_card_type' ],
	components: {
		CardDrawer
	},
	data () {
		return {
			title: null,
			card_type: this.props_card_type || null,
			card_type_disabled: this.props_card_type !== undefined,
			card_sub_type: null,
			loading: false,
			table: null,
			selected: [],
			selected_rows: [],
			results: [],
			menu_show: false,	// show context menu
			menu_x: 0,
			menu_y: 0,
			context_card: null,	// right-clicked card
			dropdowns: {
				card_types: [
					{
						text: 'Movie',
						value: 'movie'
					},
					{
						text: 'Program',
						value: 'program'
					},
					{
						text: 'Season',
						value: 'season'
					},
					{
						text: 'Show',
						value: 'show'
					}
				],
				card_sub_types: {
					null: [
						{
							text: '[empty]',
							value: ''
						},
						{
							text: 'Bonus',
							value: 'bonus'
						},
						{
							text: 'Clip',
							value: 'clip'
						},
						{
							text: 'Documentary',
							value: 'documentary'
						},
						{
							text: 'Episode',
							value: 'episode'
						},
						{
							text: 'Feature Film',
							value: 'feature_film'
						},
						{
							text: 'Featurette',
							value: 'featurette'
						},
						{
							text: 'Promo Reel',
							value: 'promoreel'
						},
						{
							text: 'Short Film',
							value: 'short_film'
						},
						{
							text: 'Show',
							value: 'show'
						},
						{
							text: 'Textless',
							value: 'textless'
						},
						{
							text: 'Trailer',
							value: 'trailer'
						}
					],
					movie: [
						{
							text: '[empty]',
							value: ''
						}
					],
					program: [
						{
							text: '[empty]',
							value: ''
						},
						{
							text: 'Bonus',
							value: 'bonus'
						},
						{
							text: 'Clip',
							value: 'clip'
						},
						{
							text: 'Documentary',
							value: 'documentary'
						},
						{
							text: 'Episode',
							value: 'episode'
						},
						{
							text: 'Feature Film',
							value: 'feature_film'
						},
						{
							text: 'Featurette',
							value: 'featurette'
						},
						{
							text: 'Promo Reel',
							value: 'promoreel'
						},
						{
							text: 'Short Film',
							value: 'short_film'
						},
						{
							text: 'Show',
							value: 'show'
						},
						{
							text: 'Textless',
							value: 'textless'
						},
						{
							text: 'Trailer',
							value: 'trailer'
						}
					],
					season: [
						{
							text: '[empty]',
							value: ''
						}
					],
					show: [
						{
							text: '[empty]',
							value: ''
						}
					]
				}
			},
			show_tree: false,
			drawer: {
				visible: false, // card drawer is shown
				card: null		// card displayed in card drawer
			}
		}
	},
	computed: {
		create_movie_tree_label () {
			let temp = window.appConfig.maestro_wf['Create Movie Tree']
			return temp === undefined || temp === null ? false : temp.label
		},
		create_movie_tree_id () {
			let temp = window.appConfig.maestro_wf['Create Movie Tree']
			return temp === undefined || temp === null ? false : temp.id
		},
		create_tv_show_tree_label () {
			let temp = window.appConfig.maestro_wf['Create TV Show Tree']
			return temp === undefined || temp === null ? false : temp.label
		},
		create_tv_show_tree_id () {
			let temp = window.appConfig.maestro_wf['Create TV Show Tree']
			return temp === undefined || temp === null ? false : temp.id
		},
		create_sub_babel_card_id () {
			let temp = window.appConfig.maestro_wf['Create Sub Babel Card']
			return temp === undefined || temp === null ? false : temp.id
		},
		index_root_card_id () {
			let temp = window.appConfig.maestro_wf['Index Root Card']
			return temp === undefined || temp === null ? false : temp.id
		},
		create_season_tree_id () {
			let temp = window.appConfig.maestro_wf['Create Season Tree']
			return temp === undefined || temp === null ? false : temp.id
		},
		update_babel_card_id () {
			let temp = window.appConfig.maestro_wf['Update Babel Card']
			return temp === undefined || temp === null ? false : temp.id
		},
		dataCount () {
			return this.table === null ? 0 : this.table.getDataCount()
		},
		pageMax () {
			return this.table === null ? 0 : this.table.getPageMax()
		}
	},
	watch: {
		$route (route, prevRoute) {
			for (let key in route.query) {
				if (['title', 'type', 'sub_type'].includes(key)) {
					if (route.query[key] !== prevRoute.query[key]) {
						this.onCurrentPathChange()
						return
					}
				}
			}
			for (let key in prevRoute.query) {
				if (['title', 'type', 'sub_type'].includes(key)) {
					if (route.query[key] !== prevRoute.query[key]) {
						this.onCurrentPathChange()
						return
					}
				}
			}
			// this.onCurrentPathChange()
		}
	},
	methods: {
		displayLauncher (jd_id = null, parameters = null, param = null) {
			this.$Bus.$emit('launcher', {
				dialog: true,
				jd_id: jd_id,
				parameters: parameters,
				param: param
			})
		},
		updateUrl () {
			if (this.$route.query.title === this.title && this.$route.query.type === this.card_type && this.$route.query.sub_type === this.card_sub_type) return
			let query = {}
			if (this.title) query.title = this.title
			if (this.card_type) query.type = this.card_type
			if (this.card_sub_type) query.sub_type = this.card_sub_type
			this.$router.push({
				path: this.$route.path,
				name: this.$route.name,
				query: query
			})
				.catch(error => {
					console.error(error.message)
				})
		},
		onCurrentPathChange () {
			if (!this.$route.query.title) {
				this.results = []
				if (this.table) this.table.setData([])
				return
			}
			this.title = this.$route.query.title === undefined ? null : this.$route.query.title
			this.card_type = this.$route.query.type === undefined ? null : this.$route.query.type
			this.card_sub_type = this.$route.query.sub_type === undefined ? null : this.$route.query.sub_type
			if (this.title) {
				this.onSearchChange()
			}
		},
		onSearchEnter () {
			this.$refs['search-input'].blur()
		},
		setTableData () {
			if (this.show_tree) {
				// Copy objects to avoid adding _children to list view elements
				var resultsTree = this.buildTree(this.results.map(r => { return {...r} }))
				if (this.table) this.table.setData(resultsTree)
			} else {
				if (this.table) this.table.setData(this.results)
			}
		},
		onSearchChange () {
			this.results = []
			if (this.table) this.table.setData([])
			if (!this.title) return
			if (this.title.length < 3) return
			if (this.loading) return
			this.loading = true
			this.$EsMaestro.card_search({title: this.title, type: this.card_type, sub_type: this.card_sub_type}, null)
				.then(results => {
					this.results = results
					this.setTableData()
				})
				.catch(error => {
					console.error(error)
				})
				.finally(() => {
					this.loading = false
				})
		},
		onMultiSelect (e) {
			e.stopImmediatePropagation()
			if (this.no_select || !this.multiselect) return
			let selectedRows = this.table.getSelectedRows()
			if (selectedRows.length > 0) {
				for (let i = 0; i < selectedRows.length; i++) {
					this.table.deselectRow(selectedRows[i])
				}
			} else {
				let rows = this.table.getRows()
				for (let i = 0; i < rows.length; i++) {
					this.table.selectRow(rows[i])
				}
			}
			this.updateMultiSelectorHtml()
		},
		onRowSelection (row) {
			row.reformat()
			this.updateMultiSelectorHtml()
		},
		onRowSelectionChanged (data, rows) {
			this.selected = data
			this.selected_rows = rows
		},
		showMenu (e) {
			e.preventDefault()
			this.menu_show = false
			this.menu_x = e.clientX
			this.menu_y = e.clientY
			this.$nextTick(() => {
				this.menu_show = true
			})
		},
		hideContext () {
			this.menu_show = false
			this.context_card = null
		},
		async indexRootCard () {
			// this.displayLauncher(this.index_root_card_id, { babel_id: this.context_card.id })
			let data = {
				jd_id: this.index_root_card_id,
				parameters: { babel_id: this.context_card.id }
			}
			this.hideContext()
			try {
				let response = await this.$ApiMaestro.jobrequest_create(data)
				if (this.$commons.checkResponse(response)) {
					this.$EventDialer(
						'info',
						false,
						'Job created',
						[`Job created`],
						null
					)
				} else {
					this.$EventDialer(
						'error',
						false,
						'Error creating job',
						['Error creating job'],
						null
					)
				}
			} catch (error) {
				this.$EventDialer(
					'error',
					false,
					'Error creating job',
					['Error creating job'],
					null
				)
			}
		},
		createSeasonTree () {
			this.displayLauncher(this.create_season_tree_id, { parent_id: this.context_card.id })
			this.hideContext()
		},
		createSubCard () {
			this.displayLauncher(this.create_sub_babel_card_id, { parent_id: this.context_card.id })
			this.hideContext()
		},
		updateBabelCard () {
			this.displayLauncher(this.update_babel_card_id, { babel_id: this.context_card.id })
			this.hideContext()
		},
		updateMultiSelectorHtml () {
			let el = document.getElementById('multi-selector')
			if (!el) return
			let icon = 'check_box_outline_blank'
			let color = ''
			let selectedCount = this.table.getSelectedData().length
			if (selectedCount > 0) {
				color = 'primary--text'
				let selectableCount = this.results.length
				if (selectableCount === selectedCount) {
					icon = 'check_box'
				} else {
					icon = 'indeterminate_check_box'
				}
			}
			el.innerHTML = `
				<i style="font-size: 24px" class="v-icon material-icons ${color}">
					${icon}
				</i>
			`
		},
		buildTable () {
			let selectable = 1
			if (this.no_select) {
				selectable = false
			} else if (this.multiselect) {
				selectable = true
			}

			let topOffset = 0
			let tableEl = document.getElementById('cards-table')
			if (tableEl) topOffset = tableEl.getBoundingClientRect().top

			let footerOffset = 0
			let footerEl = document.getElementById('footer')
			if (footerEl) footerOffset = footerEl.offsetHeight

			let table = new Tabulator('#cards-table', {
				height: `calc(100vh - ${topOffset + footerOffset}px)`,
				data: [],
				pagination: 'local',
				paginationSize: 50,
				paginationElement: document.getElementById('hidden-footer'),
				index: 'path',
				initialSort: [
					{
						column: 'label',
						dir: 'asc',
						sorter: (a, b, aRow, bRow, column, dir) => {
							let rowDataA = aRow.getData()
							let rowDataB = bRow.getData()
							let labelA = this.$maestro.babel_card_sort_label(rowDataA)
							let labelB = this.$maestro.babel_card_sort_label(rowDataB)
							return labelA.localeCompare(labelB)
						}
					}
				],
				placeholder: '-- vide --',
				reactiveData: true,
				layout: 'fitColumns',
				resizableColumns: true,
				selectable: selectable,
				cellVertAlign: 'middle',
				rowSelected: this.onRowSelection,
				rowDeselected: this.onRowSelection,
				rowSelectionChanged: this.onRowSelectionChanged,
				rowContext: (e, row) => {
					e.preventDefault()
					e.stopPropagation()
					this.context_card = row.getData()
					this.showMenu(e)
				},
				dataTree: true,
				dataTreeBranchElement: false,
				dataTreeElementColumn: 'id',
				dataTreeCollapseElement: '<i class="v-icon material-icons pr-1" style="font-size:18px">expand_more</i>',
				dataTreeExpandElement: '<i class="v-icon material-icons pr-1" style="font-size:18px">chevron_right</i>',
				dataTreeChildIndent: 14,
				columns: [
					{
						title: 'ID',
						field: 'id',
						hozAlign: 'left',
						minWidth: '120px',
						width: 120,
						vertAlign: 'middle',
						// headerSort: false,
						visible: true,
						cssClass: 'jr-id-cell header-sort',
						formatter: (cell) => {
							let rowData = cell.getRow().getData()
							let el = '<span class="text-btn"'
							if (!rowData.hasOwnProperty('_children')) {
								el += ' style="margin-left: 22px"'
							}
							el += `>${cell.getValue()}</span>`
							return el
						},
						cellClick: (e, cell) => {
							e.stopPropagation()
							let rowData = cell.getRow().getData()
							this.drawer.card = rowData
							this.drawer.visible = true
						}
					},
					{
						title: 'Label',
						field: 'label',
						formatter: (cell) => {
							let rowData = cell.getRow().getData()
							let label = this.$maestro.babel_card_label(rowData)
							return this.$sanitize(label, {ALLOWED_TAGS: [], ALLOWED_ATTR: []})
						},
						sorter: (a, b, aRow, bRow, column, dir) => {
							let rowDataA = aRow.getData()
							let rowDataB = bRow.getData()
							let labelA = this.$maestro.babel_card_sort_label(rowDataA)
							let labelB = this.$maestro.babel_card_sort_label(rowDataB)
							return labelA.localeCompare(labelB)
						}
					},
					{
						title: 'Language',
						field: 'title_language',
						width: 80
					},
					{
						title: 'Type',
						field: 'type_text',
						width: 120
					},
					{
						title: 'Sub Type',
						field: 'subtype_text',
						width: 120
					},
					{
						title: 'Ep. n°',
						field: 'episode_num',
						width: 100,
						sorter: (a, b, aRow, bRow, column, dir) => {
							let rowDataA = aRow.getData()
							let rowDataB = bRow.getData()
							let labelA = this.$maestro.babel_card_sort_epnum(rowDataA)
							let labelB = this.$maestro.babel_card_sort_epnum(rowDataB)
							return labelA.localeCompare(labelB)
						}
					},
					{
						title: 'Created',
						field: 'creation_date',
						width: 110,
						formatter: (cell) => {
							let date = cell.getValue()
							if (!date) return ''
							return moment(date).format('DD/MM/YY HH:mm')
						}
					},
					{
						title: 'Updated',
						field: 'last_update',
						width: 110,
						formatter: (cell) => {
							let date = cell.getValue()
							if (!date) return ''
							return moment(date).format('DD/MM/YY HH:mm')
						}
					}
				]
			})
			if (selectable) {
				table.addColumn({
					field: 'selector',
					width: 40,
					headerHozAlign: 'center',
					hozAlign: 'center',
					cssClass: 'select-cell',
					titleFormatter: () => {
						if (!this.multiselect) return ''
						return `<i
							style="font-size: 24px"
							id="multi-selector"
							class="v-icon material-icons">
							check_box_outline_blank
						</i>`
					},
					formatter: (cell) => {
						let row = cell.getRow()
						if (row.isSelected()) {
							return `<i
								style="font-size: 24px"
								class="v-icon
								material-icons
								primary--text">
								check_box
							</i>`
						} else {
							return `<i
								style="font-size: 24px"
								class="v-icon material-icons">
								check_box_outline_blank
							</i>`
						}
					},
					vertAlign: 'middle',
					headerSort: false,
					headerClick: this.onMultiSelect
				})
					.then(() => {
						table.moveColumn('selector', 'id', false)
					})
					.catch(error => {
						console.error(error)
					})
			}
			this.table = table
		},
		buildTree (items) {
			var tree = []		// root elements list
			var mapped_arr = {}	// elements by id
			// Build a hash table and map items to objects
			items.forEach(function (item) {
				var id = item.id
				if (!mapped_arr.hasOwnProperty(id)) {	// in case of duplicates
					mapped_arr[id] = item 				// the extracted id as key, and the item as value
				}
			})
			// If parent nodes are not included in hash table, create them
			items.forEach(function (item) {
				var parent_id = item.parent_id
				if (parent_id && !mapped_arr.hasOwnProperty(parent_id)) {
					// make up an item for root-level node
					var new_item = {}
					new_item.id = parent_id
					new_item.label = item.parent_label
					new_item.type = item.parent_type
					new_item.type_text = item.parent_type_text
					new_item.subtype = item.parent_subtype
					new_item.subtype_text = item.parent_subtype_text
					new_item.title_language = item.parent_title_language
					new_item.creation_date = item.parent_creation_date
					new_item.last_update = item.parent_last_update
					new_item.data = item.parent_data
					new_item.parent_id = item.grand_parent_id
					mapped_arr[parent_id] = new_item
				}
				var grand_parent_id = item.grand_parent_id
				if (grand_parent_id && !mapped_arr.hasOwnProperty(grand_parent_id)) {
					// make up an item for root-level node
					var new_parent_item = {}
					new_parent_item.id = grand_parent_id
					new_parent_item.label = item.grand_parent_label
					new_parent_item.type = item.grand_parent_type
					new_parent_item.type_text = item.grand_parent_type_text
					new_parent_item.subtype = item.grand_parent_subtype
					new_parent_item.subtype_text = item.grand_parent_subtype_text
					new_parent_item.title_language = item.grand_parent_title_language
					new_parent_item.creation_date = item.grand_parent_creation_date
					new_parent_item.last_update = item.grand_parent_last_update
					new_parent_item.data = item.grand_parent_data
					new_parent_item.parent_id = ''
					mapped_arr[grand_parent_id] = new_parent_item
				}
			})
			// Loop over hash table
			for (var id in mapped_arr) {
				if (mapped_arr.hasOwnProperty(id)) {
					var mapped_elem = mapped_arr[id]
					if (mapped_elem.parent_id) {
						var parent_id = mapped_elem.parent_id
						if (mapped_arr.hasOwnProperty(parent_id)) {
							if (!mapped_arr[parent_id].hasOwnProperty('_children')) {
								mapped_arr[parent_id]._children = []
							}
							mapped_arr[parent_id]._children.push(mapped_elem)
						}
					} else {
						tree.push(mapped_elem)
					}
				}
			}
			return tree
		}
	},
	mounted () {
		setTimeout(() => {
			this.buildTable()
			this.onCurrentPathChange()
		}, 0)
	}
}
</script>

<style lang="stylus" scoped>
>>>.grv-input
	.v-input__control
		margin-bottom: 0
.tabulator
	border: none
	background-color: transparent
	max-width: 100%
	>>>.tabulator-tableHolder
		overflow-x: hidden
		background-color: var(--v-background-base)
	>>>.tabulator-header
		border-bottom: 1px solid var(--v-background-lighten1)
		background-color: var(--v-background-darken1)
		.tabulator-col
			border-right: none
			background-color: var(--v-background-darken1)
		.tabulator-col.select-cell
			cursor: pointer
			&:hover
				.v-icon
					color: var(--v-primary-base) !important
	>>>.tabulator-col-title
		font-weight: normal
	>>>.tabulator-table
		background-color: var(--v-background-darken1)
		.tabulator-row-odd
			background-color: var(--v-odd-base)
		.tabulator-row-even
			background-color: var(--v-even-base)
		.tabulator-row
			height: 32px
			min-height: 32px
			max-height: 32px
			.tabulator-cell
				cursor: pointer
				border-right: none
				.tabulator-data-tree-branch
					border-color: white
		.tabulator-row:hover
			.tabulator-cell
				background-color: var(--v-background-darken1)
			.jr-id-cell:hover
				color: var(--v-primary-base)

		.tabulator-tree-level-0
			.jr-id-cell
				padding-left: 4px !important
		.tabulator-tree-level-1
			.jr-id-cell
				padding-left: 18px !important
		.tabulator-tree-level-2
			.jr-id-cell
				padding-left: 32px !important
		.tabulator-tree-level-3
			.jr-id-cell
				padding-left: 46px !important
		.tabulator-tree-level-4
			.jr-id-cell
				padding-left: 60px !important
		.tabulator-tree-level-5
			.jr-id-cell
				padding-left: 74px !important
		.tabulator-tree-level-6
			.jr-id-cell
				padding-left: 88px !important
		.tabulator-tree-level-7
			.jr-id-cell
				padding-left: 102px !important
		.tabulator-tree-level-8
			.jr-id-cell
				padding-left: 116px !important
		.tabulator-tree-level-9
			.jr-id-cell
				padding-left: 130px !important
		.tabulator-tree-level-10
			.jr-id-cell
				padding-left: 144px !important
		.tabulator-tree-level-11
			.jr-id-cell
				padding-left: 158px !important
		.tabulator-tree-level-12
			.jr-id-cell
				padding-left: 172px !important

.context-menu
	border: 1px solid var(--v-background-lighten1)
	border-radius: 4px
</style>



// WEBPACK FOOTER //
// src/components/babel.vue